import React from 'react'
import Image, { FixedObject } from 'gatsby-image'

import ResponsiveSwitch from 'components/utils/responsiveUtils/responsive-switch'

import { mobile, desktop } from './HeaderDecorator.module.scss'

interface Props {
  imgMobile: FixedObject
  imgDesktop: FixedObject
}

const HeaderDecorator = ({ imgMobile, imgDesktop }: Props) => (
  <ResponsiveSwitch
    query="(min-width: 768px)"
    renderFalse={
      <div className={mobile}>
        {imgMobile ? <Image fixed={imgMobile} /> : null}
      </div>
    }
    renderTrue={
      <div className={desktop}>
        {imgDesktop ? <Image fixed={imgDesktop} /> : null}
      </div>
    }
  />
)

export default HeaderDecorator
